export default "var foo = {\n    bar: \"baz\",\n    qux: \"quux\",\n};\n\nvar bar = {\n    bar: \"baz\",\n    qux: \"quux\"\n};"